export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/TZ-823637c6e9b3dedc5e4ce6b967bedbb3.png";